import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { initializePromotion, setSnackbarMessage } from '../model/configuratorSlice';
import { EndPoints, PromotionStatus, FeedbackMessages } from '../model/constants';
import { AccessTokenAuth } from '../auth/AccessTokenAuth';
import { DownloadTokenAuth } from '../auth/DownloadToken';
import { RequestBudgetTokenAuth } from '../auth/RequetBudgetToken';

export default function LoadPublicConfigurationService() {
    const { promotionSlug } = useParams();
    const dispatch = useDispatch();

    return useMutation(['loadPublicConfigurationQuery'], () => {
        const loadPublicConfigurationUrl = `${EndPoints.LoadPublicConfigUrl}/${promotionSlug}`;

        axios
            .get(loadPublicConfigurationUrl)
            .then((response) => {
                dispatch(initializePromotion(response.data));
            })
            .catch((error) => {
                console.log(error);
            });
    });
}
